<template>
  <UiLink :id="`popular-category-${item.id}`" :to="`/${item.slug}`" :underline="false">
    <div class="flex flex-col space-y-2 rounded-lg border border-neutral-200 p-1 pt-4 md:w-36">
      <UiText class="truncate text-center text-black">{{ item.title }}</UiText>
      <UiText type="small" class="text-primary-400">{{ $t('general.items', { count: item.item_count }) }}</UiText>
      <UiImage
        :id="`popular-category-${item.id}`"
        :alt="item.image.alt_text ?? item.title"
        :src="item.image.url"
        class="size-full self-center md:size-32"
      />
    </div>
  </UiLink>
</template>

<script setup lang="ts">
import type { PagePopularCategoryProps } from '~/components/Page/types';

defineProps<PagePopularCategoryProps>();
</script>
